import { latestPriceEth, bracketRate, } from "@bracket/platform/cachables";
import type { WEIString, } from "@bracket/types";
import { multiCaller, contract, getTokenDefinition, } from "@bracket/chainography/contracts";
import { wagmiConfig as config, } from "@bracket/platform/wagmiconfig";
import { getAggregateError, } from "@bracket/catch";



/**
 * Converts a BRKT value to USD
 * 
 * @param value - The BRKT value to convert, either as a bigint or WEIString
 * @returns A Promise that resolves to the USD value
 * 
 * @example
 * ```ts
 * const usdValue = await brktToUsd(1000000000000000000n); // 1 BRKT
 * ```
 */
export const brktToUsd = async ( value: bigint|WEIString ):Promise<number> => {
	const { address, decimals, } = getTokenDefinition("ETH_USD");
	const [ results, errors,] = await multiCaller<[ bigint, bigint, ]>(config, [
		contract("Pricing", "getLatestPrice", address),
		contract("BrktETH", "getBracketRate"),
	]);

	if(errors) {
		throw getAggregateError(errors, "Utils:brktToUsd failed to get latest price or bracket rate");
	}

	const [ priceBi, rateBi, ] = results;
	const price = Number(priceBi) / (10**decimals);
	const rate = Number(rateBi) / (10**decimals);
	return (Number(value) / 1e18) * price * rate ;

}
